/**
 * @namespace Filters
 * @exports Filters/formatDate
 * @description Format date dd/mm/yyyy
 * @date 2020/02/21
 * @license no license
 * @copywrite Answers In Retirement Limited
 */

export default (mySentence) => {
	if (!mySentence) return;
	return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
};
